<template lang="pug">
  card.quote-item-card
    h2.filename
      label.change-file
        input(
          type='file',
          name='changeFile',
          ref='changeFile'
          @change='changeFile($event.target, $event.target.files)'
        )
        span {{ item.file.name }}
      label.copy-file(v-if='itemIndex > 0')
        span(@click="copyPreviousItemConfig()") {{ $t('quote.item.copyFile') }}

    .informations
      .col
        h3.information-heading {{ $t('quote.item.generalInfo') }}
        label.arrow-drop
          h4.label-heading {{ $t('quote.item.unitOfMeasure.heading') }}
          dropdown(:itemId='quoteItem.id' id='unitOfMeasure')
        label.arrow-drop
          h4.label-heading {{ $t('quote.item.solutionType.heading') }}
          dropdown(:itemId='quoteItem.id' id='solutionType')
        label.arrow-drop
          h4.label-heading {{ $t('quote.item.materialType.heading') }}
          dropdown(:itemId='quoteItem.id' id='materialType')

      .col
        h3.information-heading {{ $t('quote.item.postProduction') }}
        label.arrow-drop
          h4.label-heading {{ $t('quote.item.finishLevel.heading') }}
          dropdown(:itemId='quoteItem.id' id='finishLevel')
        label.arrow-drop
          h4.label-heading {{ $t('quote.item.paintType.heading') }}
          dropdown(:itemId='quoteItem.id' id='paintType')
        label.arrow-drop(v-if='["basic", "automotive"].indexOf(quoteItem.paintType) !== -1')
            h4.label-heading {{ $t('quote.item.paintColor.heading') }}
            dropdown(:itemId='quoteItem.id' id='paintColor')
        label.arrow-drop
          h4.label-heading {{ $t('quote.item.postProcessOptions.heading') }}
          dropdown(:itemId='quoteItem.id' id='postProcessOptions')
        small.disclaimer(v-if='["sla-insert", "sla-tapping-threading", "sls-insert", "dmls-tapping-threading", "fdm-insert"].indexOf(quoteItem.postProcessOptions) !== -1') {{ $t('quote.item.postProcessOptions.disclaimer') }}
      .col
        h3.information-heading {{ $t('quote.item.additionalInfo') }}
        label
          h4.label-heading {{ $t('quote.item.quantity.heading') }}
          input.square-input(:value='quoteItem.quantity', @change='updateItem({ quantity: $event.target.value })', type='number')
        label.arrow-drop
          h4.label-heading {{ $t('quote.item.leadTime.heading') }}
          dropdown(:itemId='quoteItem.id' id='leadTime')
        label
          h4.label-heading {{ $t('quote.item.notes.heading') }}
          textarea.square-input(:value='quoteItem.notes', @change='updateItem({ notes: $event.target.value })')
    button.close-button(
      @click='deleteItem({ id: item.id })'
    ) close
</template>

<script>
import card from '@/components/common/card.vue'
import dropdown from '@/components/dashboard/dropdown.vue'
import { mapActions } from 'vuex'

export default {
  components: { card, dropdown },
  props: ['index', 'item'],
  data: () => ({}),
  computed: {
    itemIndex () { return this.index },
    itemId () { return this.item.id },
    quoteItem () {
      return this.$store.getters['quote/getItem'](this.item.id)
    }
  },
  methods: {
    ...mapActions('quote', ['deleteItem']),
    updateItem (args) {
      return this.$store.dispatch('quote/updateItem', { ...args, id: this.itemId })
    },
    async copyPreviousItemConfig () {
      await this.$store.dispatch('quote/copyPreviousItemConfig', { id: this.itemId })
      return this.$nextTick(() => this.$forceUpdate())
    },
    duplicateItem () {
      return this.$store.dispatch('quote/duplicateItem', { id: this.itemId })
    },
    changeFile (input, file) {
      return this.$store.dispatch('quote/updateItem', { file: file[0], id: this.itemId })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/scss/abstract/variables.scss";

  .change-file {
    display: inline-block;
    margin-right: 2em;
    cursor: pointer;

    @media only screen and (max-width: $mobile) {
      margin-bottom: 1em;
    }

    &:before {
      content: "\f044";
      display: inline;
      font-family: FontAwesome;
      font-size: 1.5em;
      margin-right: 0.5em;
    }

    &:hover {
      color: $blue;
    }

    input {
      position:absolute;
      left: -9999px;
    }
  }

  .copy-file {
    display: inline-block;
    cursor: pointer;
    margin-top:0;

    @media only screen and (max-width: $mobile) {
      margin-bottom: 1em;
    }

    &:before {
      content: "\f0c5";
      display: inline;
      font-family: FontAwesome;
      font-size: 1.5em;
      margin-right: 0.5em;
    }

    &:hover {
      color: $blue;
    }

    input {
      position:absolute;
      left: -9999px;
    }
  }

  .quote-item-card {
    position: relative;
    padding: 2em 3em;

    @media only screen and (max-width: $mobile) {
      padding: 0;
    }
  }

  .close-button {
    position: absolute;
    top: 30px;
    right: 42px;
    font-size: 0;
    color: #666666;
    line-height: .7;
    background: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    margin: 0;
    padding: 0;

    @media only screen and (max-width: $mobile) {
      top: 2px;
      right: 10px;
    }

    &:after {
      content: '\D7';
      font-size: 3.5rem;
      font-weight: 200;
    }

    &:hover:after {
      color: $blue;
    }

    &[disabled]:after {
      color: $light-gray;
    }
  }

  .filename {
    display: flex;
    align-items: center;
    margin: 1em 0 3em 0;

    font-size: 0.8em;
    font-weight: 600;
    color: $dark-gray;

    @media only screen and (max-width: $mobile) {
      text-transform: none;
      padding: 2.6em;
      line-height: normal;
      width: 100%;
      margin: 0 auto;
      display: block;
    }
  }

  .informations {
    display: flex;
    /* margin: 0 -1em; */

    @media only screen and (max-width: $mobile) {
      flex-direction: column;
    }
  }

  .col {
    flex: 1;
    padding: 0 2em;

    &:first-of-type {
      padding-left: 0;
    }

    &:last-of-type {
      padding-right: 0;
      padding-bottom: 2em !important;
    }

    @media only screen and (max-width: $mobile) {
      padding: 0 2em !important;
    }

    + .col {
      border-left: 1px solid $light-gray;

      @media only screen and (max-width: $mobile) {
        border: none;
      }
    }
  }

  .information-heading {
    margin-bottom: 2em;

    font-size: 1.2em;
    font-weight: 800;
    color: $blue;
  }

  label {
    display: block;
    position: relative;

    + label {
      margin-top: 1em;
    }

    .label-heading {
      text-transform: uppercase;
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 0.5em;
    }
  }

  .footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding-top: 1em;
  }

  .disclaimer {
    font-size: 0.7em;
    font-weight: 600;
    display: block;
    line-height: 1.3em;
    margin: 1em 0;
    font-style: italic;
  }

</style>
